// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "real_input-3XDKD";
var _3 = "boxLabelIn-d9XXo";
var _4 = "label_shrink-3GtTn";
var _5 = "input-26qiI";
var _6 = "input_filled-3dBe9";
var _7 = "underline-3w1Vs";
export { _1 as "__esModule", _2 as "real_input", _3 as "boxLabelIn", _4 as "label_shrink", _5 as "input", _6 as "input_filled", _7 as "underline" }
export default { "__esModule": _1, "real_input": _2, "boxLabelIn": _3, "label_shrink": _4, "input": _5, "input_filled": _6, "underline": _7 }
